export const environment = {
  production: true,
  baseUrl: 'https://team-api.nesoex.com',
  recaptchaSiteKey: '6Lfmw2EaAAAAAPHqVM1Y0GkePMjE3IiGHydIN0ug'
};
